import { AccountSharingModal } from 'components/Modals/index'
import { StyledAuthWrapper } from '../styles'
import ViewContainer from './container'
import LoginForm from './LoginForm'
import ForceUpdatePasswordOTP from '../ForceUpdatePassword/OTP'
import AccountDeactivated from 'components/Modals/AccountDeactivated'
import ForceUpdatePassword from '../ForceUpdatePassword/UpdatePW'
import PasswordUpdatedModal from 'components/Modals/PasswordUpdatedModal'

export default function Index({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({
        agreeToShare,
        accSharingModalVisible,
        passwordStatus,
        form,
        accountInactive,
        setAccountInactive,
        handleLogin,
        loginStateV2,
        handleLoginFacebook,
        handleLoginGoogle,
        checkIfPasswordIsUpdated,
        cancelCurrentLogin,
        verifyEmailState,
        forceResetOtpState,
        confirmOtp,
        setConfirmOtp,
        setPasswordStatus,
        passwordUpdatedModalVisible,
        handleClosePasswordUpdatedModal
      }) => (
        <StyledAuthWrapper justify="center" align="middle">
          <AccountSharingModal
            isCreateAccount={false}
            visible={accSharingModalVisible}
            agreeToShare={agreeToShare}
          />

          <PasswordUpdatedModal
            visible={passwordUpdatedModalVisible}
            handleClose={handleClosePasswordUpdatedModal}
          />

          {accountInactive && (
            <AccountDeactivated
              visible={accountInactive}
              setVisible={setAccountInactive}
            />
          )}

          {(passwordStatus === 'verify' || passwordStatus === 'login') && (
            <LoginForm
              handleLogin={handleLogin}
              form={form}
              loginStateV2={loginStateV2}
              handleLoginFacebook={handleLoginFacebook}
              handleLoginGoogle={handleLoginGoogle}
              agreeToShare={agreeToShare}
              accSharingModalVisible={accSharingModalVisible}
              passwordStatus={passwordStatus}
              checkIfPasswordIsUpdated={checkIfPasswordIsUpdated}
              cancelCurrentLogin={cancelCurrentLogin}
              verifyEmailState={verifyEmailState}
              forceResetOtpState={forceResetOtpState}
              accountInactive={accountInactive}
              {...pageProps}
            />
          )}

          {passwordStatus === 'otp' && (
            <ForceUpdatePasswordOTP
              form={form}
              confirmOtp={confirmOtp}
              setConfirmOtp={setConfirmOtp}
              setPasswordStatus={setPasswordStatus}
            />
          )}

          {passwordStatus === 'update-pw' && (
            <ForceUpdatePassword
              handleLogin={handleLogin}
              form={form}
              loginStateV2={loginStateV2}
              forceResetOtpState={forceResetOtpState}
              verifyEmailState={verifyEmailState}
              confirmOtp={confirmOtp}
              setConfirmOtp={setConfirmOtp}
            />
          )}

        </StyledAuthWrapper>
      )}
    </ViewContainer>
  )
}
